import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";
import { useLang } from "../i18n";

export function PasswordInput({ className = "", ...props }) {
  const [show, setShow] = useState(false);
  const { t } = useLang();
  return (
    <div className="relative mt-1">
      <Input {...props} type={show ? "text" : "password"} className={`rounded-lg h-12 text-base md:text-base pr-12 ${className}`} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? t("hide_password") : t("show_password")}
        className="absolute right-0 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center text-[#6E6B65]"
        data-testid={`${props["data-testid"]}-toggle`}
      >
        {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
}
